import e from "react";
import { useTheme as r, ModalHeader as m, ModalCloseButton as n } from "@chakra-ui/react";
const s = ({ modalTitle: a }) => {
  const {
    text: o,
    modalsTitleSmall: l,
    interactive: { default: d },
    modalsDefaultPadding: t
  } = r();
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    m,
    {
      "data-testid": "modal-header",
      color: o.default,
      paddingBottom: t,
      ...l
    },
    a
  ), /* @__PURE__ */ e.createElement(
    n,
    {
      color: d,
      size: "lg",
      margin: t,
      "data-testid": "modal-close-button"
    }
  ));
};
export {
  s as ModalHeader
};
